<template>
  <div class="app-container">
    <BjRouteTabs />
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      :selection="selection"
      :before-reset-search="beforeResetSearch"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <!-- <BjFormItemCode v-model="queryParams.code" label="退货出库单号" prop="code" /> -->
          <BjFormItemCode
            v-model="queryParams[isInform ? 'code' : 'queryCode']"
            :label="$t('BusinessPurchaseReturnComPage.header.queryCode')"
            :prop="isInform ? 'code' : 'queryCode'"
            :placeholder="isInform ? '' : $t('BusinessPurchaseReturnComPage.header.codeText')"
            @keyup.enter.native="handleQuery"
          />
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseReturnComPage.header.supplier')" prop="supplier">
            <BjInput
              v-model="queryParams.supplier"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('BusinessPurchaseReturnComPage.header.supplierText')"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseReturnComPage.header.type')" prop="type">
            <BjSelectLov v-model="queryParams.type" lov-code="SPUR.STOCKOUT_TYPE" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseReturnComPage.header.warehouseCode')" prop="warehouseCode">
            <BjSelectWarehouse
              v-model="queryParams.warehouseCode"
              value-code="code"
              :type-code="['logic']"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseReturnComPage.header.status')" prop="status">
            <BjSelectLov
              v-model="queryParams.status"
              :lov-code="isInform ? 'SPUR.STOCKOUT_STATUS' : 'STOCK.STOCKOUT_RESULT_STATUS'"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <BjFormItemCode
            v-model="queryParams.purchaseCode"
            :label="$t('BusinessPurchaseReturnComPage.header.purchaseCode')"
            prop="purchaseCode"
            @keyup.enter.native="handleQuery"
          />
        </el-col>
        <el-col :span="colSpan">
          <BjFormItemCode
            v-model="queryParams.spuCode"
            :label="$t('BusinessPurchaseReturnComPage.header.spuCode')"
            prop="spuCode"
            @keyup.enter.native="handleQuery"
          />
        </el-col>
        <el-col :span="colSpan">
          <BjFormItemCode
            v-model="queryParams.skuCode"
            :label="$t('BusinessPurchaseReturnComPage.header.skuCode')"
            prop="skuCode"
            @keyup.enter.native="handleQuery"
          />
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('table.createTimeText')">
            <BjDateTimerangePicker v-model="queryParamsTime_create" :placeholder="$t('table.createTimeText')"/>
          </el-form-item>
        </el-col>
        <el-col v-if="isInform" :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseReturnComPage.header.reviewTime')">
            <BjDateTimerangePicker v-model="queryParamsTime_audit" :placeholder="$t('BusinessPurchaseReturnComPage.header.reviewTime')"/>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseReturnComPage.header.deliveryTime')">
            <BjDateTimerangePicker v-model="queryParamsTime_stock" :placeholder="$t('BusinessPurchaseReturnComPage.header.deliveryTime')"/>
          </el-form-item>
        </el-col>
        <!-- <el-col v-if="isInform" :span="colSpan">
          <el-form-item label="库存类型" prop="type">
            <BjSelectLov v-model="queryParams.type" lov-code="SCHL.CHANNEL_TYPE" />
          </el-form-item>
        </el-col> -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseReturnComPage.header.logisticsBusinessName')" prop="logisticsBusinessName">
            <BjInput
              v-model="queryParams.logisticsBusinessName"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseReturnComPage.header.logisticsNo')" prop="logisticsNo">
            <BjInputCode v-model="queryParams.logisticsNo" @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation="tableOperationProp">
        <el-col>
          <template v-if="isInform">
            <el-button
              v-permission:BusinessPurchaseReturnInformAdd
              type="primary"
              class="main-btn"
              @click="onAdd"
              >{{ $t('addText') }}</el-button
            >
            <el-button
              v-permission:BusinessPurchaseReturnInformEdit
              :disabled="tableOperationProp.notSingle"
              type="primary"
              @click="onEdit"
              >{{ $t('editText') }}</el-button
            >

            <el-dropdown v-hasDropdownChildren @command="onAudit">
              <el-button type="primary">
                {{ $t('BusinessPurchaseReturnComPage.review') }}<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-permission:BusinessPurchaseReturnInform_Audit
                  :command="$t('BusinessPurchaseReturnComPage.review')"
                  :disabled="tableOperationProp.notSelected"
                  >{{ $t('BusinessPurchaseReturnComPage.review') }}</el-dropdown-item
                >
                <el-dropdown-item
                  v-permission:BusinessPurchaseReturnInform_UnAudit
                  :command="$t('BusinessPurchaseReturnComPage.antiAudit')"
                  :disabled="tableOperationProp.notSingle"
                  >{{ $t('BusinessPurchaseReturnComPage.antiAudit') }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
            <el-button
              v-permission:BusinessPurchaseReturnInform_Cancel
              type="primary"
              :disabled="tableOperationProp.notSingle"
              @click="onCancel"
              >{{ $t('cancelText') }}</el-button
            >
            <el-button
              v-permission:BusinessPurchaseReturnInform_Return
              type="primary"
              :disabled="tableOperationProp.notSingle"
              @click="onDeliver"
              >{{ $t('BusinessPurchaseReturnComPage.returnWarehouse') }}</el-button
            >
          </template>
          <el-button
            v-permission="
              isInform
                ? 'BusinessPurchaseReturnInform_Export'
                : 'BusinessPurchaseReturnResult_Export'
            "
            type="primary"
            @click="onExport"
            >{{ $t('BusinessPurchaseReturnComPage.export') }}</el-button
          >
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
          >
            <template slot-scope="{ row }">
              <template v-if="false" />
              <span v-else-if="col.prop === 'code'" class="link" @click="onDetail(row)">
                {{ row[col.prop] }}
              </span>
              <span
                v-else-if="col.prop === 'stockoutCode'"
                class="link"
                @click="onInformDetail(row)"
              >
                {{ row[col.prop] }}
              </span>
              <span v-else>{{ row[col.prop] | timeFilters(row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || 'right'"
            align="center"
          >
            <template slot-scope="{ row }">
              <el-button
                v-permission:BusinessPurchaseReturnIndex_Edit
                type="text"
                @click="onEdit(row)"
                >{{ $t('editText') }}</el-button
              >
              <!-- <el-button v-permission:BusinessPurchaseReturnIndex_Log type="text">{{ $t('logText') }}</el-button> -->
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { purchaseApi } from '@/api';
import { STATUS_YES_TRUE } from '@/utils/constants';
import { downloadBlob } from '@/utils/index';

export default {
  name: 'BusinessPurchaseReturnIndex',
  mixins: [pageMiXin],
  props: {
    pageType: {
      type: String,
      default: 'inform',
      validator: value => {
        return ['inform', 'result'].includes(value);
      },
    },
  },
  data() {
    return {
      STATUS_YES_TRUE,
      queryApi: purchaseApi.getStockouts,
      // 查询参数
      queryParamsTime_create: null,
      queryParamsTime_audit: null,
      queryParamsTime_stock: null,
      queryParams: {
        code: null,
        supplier: null,
        type: null,
        warehouseCode: null,
        purchaseCode: null,
        status: null,
        spuCode: null,
        skuCode: null,
        creationDateBegin: null,
        creationDateEnd: null,
        auditDateBegin: null,
        auditDateEnd: null,
        stockinDateBegin: null,
        stockinDateEnd: null,
        logisticsBusinessName: null,
        logisticsNo: null,
      },
      labelsVersion: 0,
      commonErrorText: this.$t('BusinessPurchaseReturnComPage.errorText'),
    };
  },
  computed: {
    isInform() {
      return this.pageType === 'inform';
    },
    labelList() {
      let LIST = [
        // { label: '退货出库通知单号', prop: 'code', isCheck: true, disabled: false, width: '160' },
        {
          label: 'BusinessPurchaseReturnComPage.table.statusMeaning',
          prop: 'statusMeaning',
          isCheck: true,
          disabled: false,
          width: '170',
        },
        {
          label: 'BusinessPurchaseReturnComPage.table.typeMeaning',
          prop: 'typeMeaning',
          isCheck: true,
          disabled: false,
          width: '170',
        },
        { label: 'BusinessPurchaseReturnComPage.table.warehouseName', prop: 'warehouseName', isCheck: true, disabled: false, width: '160' },
        { label: 'BusinessPurchaseReturnComPage.table.supplierCode', prop: 'supplierCode', isCheck: true, disabled: false, width: '160' },
        { label: 'BusinessPurchaseReturnComPage.table.supplierName', prop: 'supplierName', isCheck: true, disabled: false, width: '160' },
        { label: 'BusinessPurchaseReturnComPage.table.purchaseCode', prop: 'purchaseCode', isCheck: true, disabled: false, width: '170' },
        {
          label: 'BusinessPurchaseReturnComPage.table.logisticsBusinessName',
          prop: 'logisticsBusinessName',
          isCheck: true,
          disabled: false,
          width: '160',
        },
        { label: 'BusinessPurchaseReturnComPage.table.logisticsNo', prop: 'logisticsNo', isCheck: true, disabled: false, width: '160' },
        { label: 'BusinessPurchaseReturnComPage.table.planQty', prop: 'planQty', isCheck: true, disabled: false, width: '160' },
        { label: 'BusinessPurchaseReturnComPage.table.alreadyQty', prop: 'alreadyQty', isCheck: true, disabled: false, width: '160' },
        { label: 'BusinessPurchaseReturnComPage.table.amount', prop: 'amount', isCheck: true, disabled: false, width: '160' },
        { label: 'BusinessPurchaseReturnComPage.table.recipientName', prop: 'recipientName', isCheck: true, disabled: false, width: '160' },
        { label: 'BusinessPurchaseReturnComPage.table.recipientPhone', prop: 'recipientPhone', isCheck: true, disabled: false, width: '160' },
        {
          label: 'BusinessPurchaseReturnComPage.table.recipientAddress',
          prop: 'recipientAddress',
          isCheck: true,
          disabled: false,
          width: '160',
        },
        { label: 'table.remarkText', prop: 'remark', isCheck: true, disabled: false, width: '160' },
        { label: 'table.creatorText', prop: 'createdName', isCheck: true, disabled: false, width: '160' },
        { label: 'table.createTimeText', prop: 'creationDate', isCheck: true, disabled: false, width: '160' },
        { label: 'BusinessPurchaseReturnComPage.table.auditDate', prop: 'auditDate', isCheck: true, disabled: false, width: '160' },
        { label: 'BusinessPurchaseReturnComPage.table.auditName', prop: 'auditName', isCheck: true, disabled: false, width: '160' },
        { label: 'BusinessPurchaseReturnComPage.table.stockoutDate', prop: 'stockoutDate', isCheck: true, disabled: false, width: '160' },
        { label: 'BusinessPurchaseReturnComPage.table.sourceMeaning', prop: 'sourceMeaning', isCheck: true, disabled: false, width: '160' },
      ];
      if (!this.isInform) {
        LIST.unshift({
          label: 'BusinessPurchaseReturnComPage.table.code',
          prop: 'code',
          isCheck: true,
          disabled: false,
          width: '170',
        });
        LIST = LIST.filter(row => !['planQty'].includes(row.prop));
      }
      LIST.unshift({
        label: 'BusinessPurchaseReturnComPage.table.stockoutCode',
        prop: this.isInform ? 'code' : 'stockoutCode',
        isCheck: true,
        disabled: false,
        width: '210',
      });
      return LIST;
    },
  },
  watch: {
    pageType: {
      handler(v) {
        this.queryApi =
          purchaseApi[this.pageType === 'inform' ? 'getStockouts' : 'getStockoutResults'];
      },
      immediate: true,
    },
    queryParamsTime_create(v) {
      this.queryParams.creationDateBegin = (v || [])[0];
      this.queryParams.creationDateEnd = (v || [])[1];
    },
    queryParamsTime_audit(v) {
      this.queryParams.auditDateBegin = (v || [])[0];
      this.queryParams.auditDateEnd = (v || [])[1];
    },
    queryParamsTime_stock(v) {
      this.queryParams.stockoutDateBegin = (v || [])[0];
      this.queryParams.stockoutDateEnd = (v || [])[1];
    },
  },
  mounted() {},
  methods: {
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParamsTime_create = null;
      this.queryParamsTime_audit = null;
      this.queryParamsTime_stock = null;
      return new Promise(resolve => {
        resolve();
      });
    },
    onDetail(row) {
      const name = this.isInform
        ? 'BusinessPurchaseReturnInformDetail'
        : 'BusinessPurchaseReturnResultDetail';
      this.$toPage(name, {
        id: row.id,
        code: row.code,
      });
    },
    onInformDetail(row) {
      this.$toPage('BusinessPurchaseReturnInformDetail', { id: row.id, code: row.stockoutCode });
    },
    /** 新增 */
    onAdd() {
      this.$router.push({
        name: 'BusinessPurchaseReturnInformAdd',
      });
    },
    /** 编辑操作 */
    onEdit() {
      const { id, code, status } = this.selectedRows[0];
      if (status !== 'WAIT_AUDIT') {
        this.msgError(this.$t('BusinessPurchaseReturnComPage.msgError1'));
        return;
      }
      this.$router.push({
        name: 'BusinessPurchaseReturnInformEdit',
        query: {
          id,
          code,
        },
      });
    },
    /** 审核 */
    onAudit(command) {
      const setData = new Set(this.selectedRows.map(e => e.status));
      // 审核
      if (command === this.$t('BusinessPurchaseReturnComPage.review')) {
        // 混合状态并且不是待审核
        if (setData.size > 1 || (setData.size === 1 && !setData.has('WAIT_AUDIT'))) {
          this.msgError(this.commonErrorText);
          return;
        }
      } else {
        // 状态非待出库相关
        if (!setData.has('WAIT_STOCKOUT')) {
          this.msgError(this.commonErrorText);
          return;
        }
      }
      this.$MessageBox({ content: `${this.$t('BusinessPurchaseReturnComPage.msgBox1')}${command}${this.$t('BusinessPurchaseReturnComPage.msgBox2')}` }).then(() => {
        const Api = command === this.$t('BusinessPurchaseReturnComPage.review') ? 'auditStockouts' : 'antiAuditStockouts';
        const ids = {
          ids: this.selectedRows.map(row => {
            const { id, objectVersionNumber } = row;
            return {
              id,
              objectVersionNumber,
            };
          }),
        };
        this.operationApi(Api, ids);
      });
    },
    /** 取消 */
    onCancel() {
      // 判断待审核状态下才能取消
      if (this.selectedRows[0].status !== 'WAIT_AUDIT') {
        this.msgError(this.commonErrorText);
        return;
      }
      this.$MessageBox({ content: this.$t('BusinessPurchaseReturnComPage.msgBox3') }).then(() => {
        const ids = {
          ids: this.selectedRows.map(row => {
            const { id, objectVersionNumber } = row;
            return {
              id,
              objectVersionNumber,
            };
          }),
        };
        this.operationApi('cancelStockouts', ids);
      });
    },
    /** 退货出库 */
    onDeliver() {
      const { status } = this.selectedRows[0];
      // [WAIT_STOCKOUT, '待出库'],[WAIT_INFORM_WMS, '待通知WMS'],
      if (['WAIT_STOCKOUT', 'WAIT_INFORM_WMS'].includes(status)) {
        this.$MessageBox({ content: this.$t('BusinessPurchaseReturnComPage.msgBox4') }).then(() => {
          const ids = this.selectedRows.map(row => row.id);
          this.operationApi('generateResultsByStockout', ids);
        });
      } else {
        this.msgError(this.$t('BusinessPurchaseReturnComPage.msgError2'));
      }
    },
    /** 导出 */
    onExport() {
      purchaseApi[this.isInform ? 'reportStockouts' : 'reportResultsByStockout'](
        this.queryParams,
      ).then(res => {
        downloadBlob(
          res,
          (this.isInform ? this.$t('BusinessPurchaseReturnComPage.downName1') : this.$t('BusinessPurchaseReturnComPage.downName2')) +
            new Date().toLocaleString() +
            '.xlsx',
        );
      });
    },
    /** 删除 */
    /** 批量删除操作 */
    onDeleteSelected() {
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('chooseText'));
        return;
      }
      const ids = this.selectedRows.map(e => e.id);
      this.$confirm(this.$t('toast.delAllTipText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.batchDeleteApi({ ids: ids });
        })
        .catch(() => {});
    },
    batchDeleteApi(ids) {
      purchaseApi.deleteThirdShopMappings({ ids }).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    operationApi(apiName, DATA) {
      purchaseApi[apiName](DATA).then(res => {
        if (!res.failed) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
